import LogoIsbasiModal from './Modals/LogoIsbasi/LogoIsbasiModal';
import WebHooksModal from './Modals/WebHooksModal';
import WhatsappBusinessModal from './Modals/WhatsappBusiness/WhatsappBusinessModal';

export default [
	{ keyString: 'otoWebhook', type: 'otoWebhook', component: WebHooksModal },
	{
		keyString: 'whatsappBusiness',
		type: 'others',
		component: WhatsappBusinessModal
	},
	{ keyString: 'logoIsbasi', type: 'others', component: LogoIsbasiModal }
];
